@if (awaitingForWalletExtension()) {
  <div class="fixed inset-0 bg-black/50 flex items-center justify-center z-in-front flex-col">
    <!-- Spinner Element -->
    <img [src]="getSelectedWalletPng()" class="w-40 h-40 animate-bounce" />
    <div class="w-12 h-12 border-4 border-t-blue-500 border-blue-200 rounded-full animate-spin"></div>
  </div>
}

<div class="max-w-[600px] mx-auto space-y-2 mt-3">
  <!-- I owe section -->
  <div class="bg-[#7a849b1a] rounded-xl border border-[#F1F1F1] p-3 [&&]:py-1 relative" id="amount-received">
    <i
      class="ph ph-info no-arrow clickable absolute right-2 top-2 z-10"
      #tooltip="matTooltip"
      matTooltip="{{ 'iOweExplanation' | translate }}"
      matTooltipPosition="below"
      toggleMatTooltip
    ></i>
    <div class="flex items-center gap-2 mb-2">
      <span
        class="payment-report-label [&&]:text-black font-medium confirmation-tab-mobile-label text-nowrap"
        [innerHTML]="'iOwe' | translate: { receiver: '' }"
      ></span>
      <app-nicky-user-guest-card
        [isLoading]="false"
        [targetUser]="paymentStore.targetUserComputed()"
        [hideClearButton]="true"
        [noPayerInfoTooltip]="true"
        class="max-w-[85%]"
      >
      </app-nicky-user-guest-card>
      <button class="text-gray-400 hover:text-gray-600"></button>
    </div>
    <div class="flex items-center gap-2 flex-wrap">
      <div class="text-xl gap-2 flex flex-wrap items-center w-full">
        <mat-icon
          [svgIcon]="paymentStore.paymentDetailsComputed().settlementAsset?.assetTicker || ''"
          [matTooltip]="paymentStore.paymentDetailsComputed().settlementAsset?.assetTicker"
        ></mat-icon>
        <span class="font-medium confirmation-tab-mobile-label">{{
          paymentStore.paymentDetailsComputed().settlementAsset?.assetTicker
        }}</span>
        <span class="confirmation-tab-mobile-label"
          >{{ formatPrice(paymentStore.paymentDetailsComputed().settlementAmount || '', true) }}
          <!-- <i class="ph ph-copy copy-button" (click)="copyToClipboard(paymentDetails.settlementAmount || '')"></i> -->
        </span>
        <span
          class="w-fit max-w-[120px] md:min-w-[120px] md:text-[12px] text-[#929292] font-bold uppercase leading-normal p-0 ml-auto text-right confirmation-tab-lower-label"
        >
          {{ paymentStore.paymentDetailsComputed().settlementAsset | currencyTranslation | async }}
        </span>
      </div>
      @if (paymentStore.paymentDetailsComputed().reference) {
        <div
          class="w-full text-left confirmation-tab-mobile-label italic truncate"
          matTooltip="{{ paymentStore.paymentDetailsComputed().reference }}"
          matTooltipPosition="above"
          toggleMatTooltip
        >
          {{ 'relativeTo' | translate }} {{ paymentStore.paymentDetailsComputed().reference }}
        </div>
      }
    </div>
  </div>

  <!-- So I am sending section -->
  <div class="bg-[#efffce] rounded-xl p-3 [&&]:py-1 border border-[#F1F1F1] relative" id="amount-paid">
    <i
      class="ph ph-info no-arrow clickable absolute right-2 top-2 z-10"
      #tooltip="matTooltip"
      matTooltip="{{ 'iAmSendingExplanations' | translate }}"
      matTooltipPosition="above"
      toggleMatTooltip
    ></i>
    <div class="flex justify-between items-center mb-2">
      <div class="flex items-center gap-2">
        <span class="payment-report-label confirmation-tab-mobile-label italic">{{ 'soIAmSending' | translate }}</span>
      </div>
    </div>
    <div class="flex flex-wrap items-center">
      <div class="text-xl gap-2 flex flex-wrap items-center w-full">
        <mat-icon
          [svgIcon]="paymentStore.paymentDetailsComputed().payingAsset?.assetTicker || ''"
          [matTooltip]="paymentStore.paymentDetailsComputed().payingAsset?.assetTicker"
        ></mat-icon>
        <span class="font-medium confirmation-tab-mobile-label">{{
          paymentStore.paymentDetailsComputed().payingAsset?.assetTicker
        }}</span>
        <span class="font-semibold confirmation-tab-mobile-label">
          {{ formatPrice(paymentStore.paymentDetailsComputed().quote?.price) }}
          @if (paymentStore.paymentDetailsComputed().quote?.price) {
            <i
              class="ph ph-copy copy-button"
              (click)="
                copyToClipboard(
                  paymentStore.paymentDetailsComputed().quote?.price || '',
                  'theSendingAmountHasBeenCopiedToTheClipboard'
                )
              "
            ></i>
          }
        </span>
        <span
          class="w-fit max-w-[120px] md:min-w-[120px] text-[12px] text-[#929292] font-bold uppercase leading-normal p-0 ml-auto text-right confirmation-tab-lower-label"
        >
          {{ formatedAssetName() }}
        </span>
      </div>
      <!-- <div class="text-left w-full flex gap-1 mt-2 md:mt-2">
        <span class="font-medium italic confirmation-tab-mobile-label">via</span>
        <a class="font-medium underline confirmation-tab-mobile-label">{{
          getNetworkName().toLowerCase() + 'Network' | translate
        }}</a>
      </div> -->
    </div>
  </div>

  <!-- Progress section -->
  <div
    class="space-y-2 rounded-lg custom-border-gray-light text-base text-left font-normal w-full shadow-[0_0_4px_#0000000d] p-2 [&&]:px-x-small"
    id="payment-deadline"
  >
    <div class="flex justify-between items-center">
      <div class="flex items-center gap-2">
        <h2 class="font-bold text-base text-[#202b42] confirmation-tab-lower-label flex flex-nowrap">
          {{ 'openYourWalletAndSendPayment' | translate }}

          <i
            class="ph ph-info clickable tooltip-icon"
            #tooltip="matTooltip"
            matTooltip="{{ 'useYourPreferredCryptoWallet' | translate }}"
            matTooltipPosition="above"
            toggleMatTooltip
          ></i>
        </h2>
      </div>
      <span class="font-semibold text-[#202b42] text-base confirmation-tab-mobile-label">
        {{ !sameAssets() ? paymentUtils.formatTimer(refreshQuotesTimerInSeconds.toString()) : '' }}
      </span>
    </div>
    <div
      class="h-1 rounded-full"
      [style.background]="fillTimeLapseBar(refreshQuotesTimerInSeconds, totalTimeInMinutes * 60)"
    ></div>
  </div>

  @if (!paymentStore.noWallet()) {
    <!-- QR and Address section -->
    <div class="flex gap-6 !mb-6">
      <div class="w-[100px] h-[100px] bg-white p-2 rounded-lg">
        @if (paymentStore.paymentDetailsComputed().selectedReceiverWallet?.cryptoAddress?.address) {
          <button>
            <app-qr-code-handler-component
              [errorLabel]="'ERROR.opsTryAgainOrCopyTheAddress'"
              [qrOptions]="{
                ariaLabel: 'Nicky Payment Confirmation QR-code',
                alt: 'Nicky Payment Confirmation QR-code',
                qrData: paymentStore.paymentDetailsComputed().selectedReceiverWallet?.cryptoAddress?.address || '',
                allowEmptyString: true,
                width: 105,
                title: 'address' | translate,
              }"
              id="payment-qr-code"
              (clickOutput)="openQrScanModal()"
              (qrCodeErrorOutput)="qrCodeError.set($event)"
            ></app-qr-code-handler-component>
          </button>
        }
        @if (!qrCodeError()) {
          <button (click)="openQrScanModal()">
            <a
              class="text-bg-main w-full block text-center ml-3 md:mt-[7px] font-sans text-[12px] font-bold confirmation-tab-lower-label"
              >{{ 'expand' | translate }}</a
            >
          </button>
        }
      </div>

      <div class="flex-1 space-y-4 mb-2">
        <div>
          <div class="flex items-center justify-between">
            <h3
              class="font-semibold text-[#202b42] text-base confirmation-tab-lower-label text-left"
              [innerHTML]="getAddressViaNetwork()"
            ></h3>
          </div>
          <div
            class="break-all text-left text-sm md:tracking-[-0.02em] text-[#929292] confirmation-tab-lower-label"
            id="payment-address"
          >
            {{ paymentStore.paymentDetailsComputed().selectedReceiverWallet?.cryptoAddress?.address }}
            <button class="text-gray-500 hover:text-gray-700 text-sm">
              <i
                class="ph ph-copy copy-button"
                (click)="
                  copyToClipboard(
                    paymentStore.paymentDetailsComputed().selectedReceiverWallet?.cryptoAddress?.address || '',
                    'theRecipientCryptoAddressHasBeenCopiedToTheClipboard'
                  )
                "
              ></i>
            </button>
          </div>
        </div>

        <div id="current-rate">
          <div class="flex items-center gap-2">
            <h3
              class="payment-report-label text-[#202b42] text-base confirmation-tab-mobile-label"
              [innerHTML]="'payment_flow.lockedRate' | translate"
            ></h3>
            <i
              class="ph ph-info clickable tooltip-icon"
              #tooltip="matTooltip"
              matTooltip="{{ paymentUtils.getCoinMarketTooltip() }}"
              matTooltipPosition="above"
              toggleMatTooltip
            ></i>
          </div>

          <div class="text-gray-500 text-left">
            @if (!flippedRates) {
              <span class="rates-asset-label text-[#929292] confirmation-tab-mobile-label">
                {{ paymentStore.paymentDetailsComputed().payingAsset?.assetTicker }} 1
              </span>
              =
              <span class="text-[#929292] confirmation-tab-mobile-label">
                {{ paymentStore.paymentDetailsComputed().settlementAsset?.assetTicker }}
                {{ formatPrice(paymentStore.paymentAmountInfoComputed().payingAssetPrice || 1, true) }}
              </span>
            } @else {
              <span class="rates-asset-label text-[#929292] confirmation-tab-mobile-label">
                {{ paymentStore.paymentDetailsComputed().settlementAsset?.assetTicker }} 1
              </span>
              =
              <span class="text-[#929292] confirmation-tab-mobile-label">
                {{ paymentStore.paymentDetailsComputed().payingAsset?.assetTicker }}
                {{ formatPrice(1 / (paymentStore.paymentAmountInfoComputed().assetConversionRateAmount || 1)) }}
              </span>
            }
            <button
              class="ml-0 md:ml-2 text-bg-main font-bold text-left confirmation-tab-lower-label text-[12px]"
              (click)="flippedRates = !flippedRates"
            >
              {{ 'flip' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>

    @if (availableWallets.length > 0 && payingAssetSupportsBrowserExtension()) {
      <h3 class="metamask-pay text-left w-full confirmation-tab-lower-label text-[12px] flex items-center">
        @if (availableWallets.length > 1) {
          {{ 'youHaveWalletExtensionsInstalledClickToPayWithOneOfThem' | translate: { walletExtension: undefined } }}
        }
        @for (availableWallet of availableWallets; track availableWallet.provider) {
          <button (click)="startPaymentWallet(availableWallet)" class="flex items-center">
            <mat-icon
              class="ml-2"
              [svgIcon]="availableWallet.info.name.replaceAll(' ', '').toLocaleLowerCase()"
            ></mat-icon>
            @if (availableWallets.length === 1) {
              <span class="underline text-sm font-semibold ml-2">
                {{ 'clickHereToPayWith' | translate: { walletExtension: availableWallet.info.name } }}
              </span>
            }
          </button>
        }
      </h3>
    }

    <!-- Footer text -->
    <h1
      class="terms-inform text-xsm text-left text-[12px] font-normal text-[#929292] confirmation-tab-lower-label"
      [innerHTML]="'nickyIsAPeerToPeer' | translate"
    ></h1>
  }

  @if (paymentStore.noWallet()) {
    <div class="text-red-500 font-medium block [&&]:my-4 text-left confirmation-tab-mobile-label">
      {{
        'userTemporarilyUnableToReceivePayments'
          | translate: { assetName: paymentStore.paymentDetailsComputed().payingAsset?.assetTicker }
      }}
    </div>
  }
</div>

@if (invalidQuote) {
  <label class="block text-red-500 my-2 text-left">{{
    'PAYMENT_REPORT.weEncounteredATemporaryProblemFetchingTheRate' | translate
  }}</label>
}

@if (!invalidQuote) {
  <div
    class="navigation-buttons flex-wrap border-t border-gray-200 m-2 bottom-0 left-0 right-0 bg-white flex justify-end pt-4"
  >
    <!-- Right Section -->
    <div class="right-section flex items-center gap-2">
      <!-- Back Button -->
      <app-nicky-button (click)="onBack()" variant="text">
        {{ 'back' | translate }}
      </app-nicky-button>
      <!-- Next Button -->
      <app-nicky-button
        [disabled]="paymentStore.noWallet()"
        (click)="validatePayment()"
        id="next"
        [customLeftClasses]="'italic'"
      >
        {{ 'iHaveSent' | translate }}
      </app-nicky-button>
      <!-- Reset Button -->
      <!-- <button (click)="onReset()">
        {{ getResetButtonLabel() }}
      </button> -->
    </div>

    @if (paymentStore.paymentDetailsComputed().shouldKeepQuote) {
      <label class="block text-red-500 my-2 text-right w-full">
        {{ 'payment_flow.attentionQuoteIsOutdated' | translate }}
      </label>
    }
  </div>
}
